/**
 * @file Album folder tags related queries.
 */

import gql from 'graphql-tag';

import {
  AlbumAlbumFolderTagDetails,
  AlbumFolderTagDetails,
  AlbumPhotoAlbumFolderTagDetails,
  AlbumFolderPhotoSearchDetails,
  AlbumPhotoSearchDetails,
} from '../fragments/album-folder-tags';
import { AlbumFolderBaseDetails } from '../fragments/album-folder';

export const TagTemplates = gql`
  query tagTemplates {
    tagTemplates(slice: { limit: 999 }) {
      tag_templates {
        total
        records {
          ... on IRecord {
            id
          }
          ... on ITagTemplate {
            name
            type
          }
          ... on UniformTagTemplate {
            gender
            uniform_enabled
            uniform_numbered
          }
        }
      }
    }
  }
`;

export const AlbumFolderTags = gql`
  query AlbumFolderTags($id: RecordID!) {
    albumFolder(id: $id) {
      id
      ...AlbumFolderBaseDetails
      tags(slice: { limit: 999 }) {
        total
        records {
          ...AlbumFolderTagDetails
        }
      }
    }
  }
  ${AlbumFolderBaseDetails}
  ${AlbumFolderTagDetails}
`;

export const AlbumAlbumFolderTagsOnAlbum = gql`
  query albumAlbumFolderTags($id: RecordID!) {
    album(id: $id) {
      id
      last_uploaded_at
      album_folder_tags(slice: { limit: 999 }) {
        total
        records {
          ...AlbumAlbumFolderTagDetails
        }
      }
      root_album_folder {
        id
        tags(slice: { limit: 999 }) {
          total
          records {
            ...AlbumFolderTagDetails
          }
        }
      }
    }
  }
  ${AlbumAlbumFolderTagDetails}
  ${AlbumFolderTagDetails}
`;

export const AlbumFolderTagsFromAlbum = gql`
  query albumFolderTagsFromAlbum($id: RecordID!) {
    album(id: $id) {
      id
      matching_tags_enabled
      root_album_folder {
        id
        matching_disabled
        tags(slice: { limit: 999 }) {
          total
          records {
            ...AlbumFolderTagDetails
          }
        }
      }
    }
  }
  ${AlbumFolderTagDetails}
`;

export const AlbumPhotoAlbumFolderTagsOnPhoto = gql`
  query albumPhotoAlbumFolderTagsOnPhoto(
    $photo_id: RecordID!
    $album_id: RecordID!
  ) {
    photo(id: $photo_id) {
      id
      album_folder_tags(slice: { limit: 999 }, album_id: $album_id) {
        total
        records {
          ...AlbumPhotoAlbumFolderTagDetails
        }
      }
    }
  }
  ${AlbumPhotoAlbumFolderTagDetails}
`;

export const AlbumFolderPhotoSearch = gql`
  query albumFolderPhotoSearch($id: RecordID!) {
    albumFolder(id: $id) {
      id
      photo_searches(slice: { limit: 999 }) {
        total
        records {
          id
          ...AlbumFolderPhotoSearchDetails
        }
      }
    }
  }
  ${AlbumFolderPhotoSearchDetails}
`;

export const AlbumPhotoSearch = gql`
  query albumPhotoSearch($id: RecordID!) {
    album(id: $id) {
      id
      photo_searches(slice: { limit: 999 }) {
        total
        records {
          id
          ...AlbumPhotoSearchDetails
        }
      }
    }
  }
  ${AlbumPhotoSearchDetails}
`;
